import { render } from "./CalendarApp1.vue?vue&type=template&id=7e25bf44&ts=true"
import script from "./CalendarApp1.vue?vue&type=script&lang=ts"
export * from "./CalendarApp1.vue?vue&type=script&lang=ts"

import "./CalendarApp1.vue?vue&type=style&index=0&id=7e25bf44&lang=scss"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__